import type { FaireProductEntity } from "../../entity_types/product";

export const p_vm2ypeff3z: FaireProductEntity = {
  token: "p_vm2ypeff3z",
  type: "product",
  name: "Clear Tiki Glasses -15oz (1pc)",
  brandName: "Lemonsoda",
  imageUrl:
    "https://cdn.faire.com/fastly/219a1348dbf982dcb69a529e39923eab4a68a3e7974b9a34876ee00a8abb5acc.jpeg",
  priceDollars: 3,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/f14adfbdfd0ea26e028fe32a5baaa1e89973fbef50c1d543fdeebfed1b93bf52.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
